<script>
  export let user = false, page = ''
  let title = "Jump to the "
</script>
{#if user}
  {#if user.user_level_id < 3}
<nav class="fixed w-screen flex justify-between items-center px-4 py-1 text-xs uppercase bg-obsidian text-white z-50">
  <div class="flex w-3/4 space-x-4">
    {#if page === 'player'}
    <a href="/admin" title="{title}Content Management System">Admin</a>
    {:else}
    <a href="/player" title="{title}Consumer Media Player">Player</a>
    {/if}
  </div>
  <div class="flex w-1/4 justify-end space-x-4">
    <span>{user.first_name + ' ' + user.last_name}</span>
    <a href="/logout" title="Logout">Logout</a>
  </div>
</nav>
  {/if}
{/if}
